import { combineReducers, configureStore } from '@reduxjs/toolkit';
import sipAndSwpSlice from '../redux/calculations/slice'
import lumpsumSlice from '../redux/calculations/lumpsumSlice'
import cookieConsentSlice from '../redux/calculations/cookieConsentSlice'
import calculatorSlice from '../redux/calculations/calculaterSlice'
import personalLoanSlice from '../redux/calculations/personalLoanSlice'
import fdSlice from '../redux/calculations/fdSlice';
import rdSlice from '../redux/calculations/rdSlice';
import educationSlice from '../redux/calculations/educationSlice';
import creditSlice from '../redux/calculations/creditSlice';
import bussinessSlice from '../redux/calculations/bussinessSlice'
import earlyLoanSlice from '../redux/calculations/earlyLoanSlice';
import dtiSlice from '../redux/calculations/dtiSlice';
import networthSlice from './calculations/networthSlice';
import gstSlice from './calculations/gstSlice';
import vatSlice from './calculations/vatSlice';
import salarySlice from './calculations/salarySlice';
import pensionSlice from './calculations/pensionSlice';
import ltvSlice from './calculations/ltvSlice';
import savingslice from './calculations/savingSlice';
import carSlice from './calculations/carSlice';
import contributionSlice from './calculations/contributionSlice'
import mortgageSlice from './calculations/mortgageSlice';
import loadingReducer from './loading/loadingSlice';
import settingsReducer from './settings/settingsSlice';
import aiAnalysisReducer from './aiAnalysis/aiAnalysisSlice';


const reducers = combineReducers({
  sip: sipAndSwpSlice,
  lum: lumpsumSlice,
  cookie: cookieConsentSlice,
  calculator: calculatorSlice,
  personalLoanCalculator: personalLoanSlice,
  fdCalculator:fdSlice,
  rdCalculator: rdSlice,
  educationCalculator:educationSlice,
  creditCalculator: creditSlice,
  bussinessCalculator: bussinessSlice,
  earlyLoanCalculator:earlyLoanSlice,
  dtiCalculator: dtiSlice,
  networthCalculator: networthSlice,
  gstCalculator: gstSlice,
  vatCalculator: vatSlice,
  salaryCalculator:salarySlice,
  pensionCalculator:pensionSlice,
  ltvCalculator:ltvSlice,
  savingsCalculator:savingslice,
  carCalculator:carSlice,
  contributionCalculator :contributionSlice,
  mortgageCalculator: mortgageSlice,
  loading: loadingReducer,
  settings: settingsReducer,
  aiAnalysis: aiAnalysisReducer,

})

const store = configureStore({
  reducer:  reducers,
});


export default store;